import React, { useContext, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import PsContext from "../../context";
import { _GET_PAGE } from "../../models/fieldSettings";

const HomeAboutUsPage = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  const field = (fieldName) => props?.dataSource?.[fieldName];

  useEffect(() => {
    loadPage();
  }, []);

  const loadPage = () => {
    setLoader(true);
    _GET_PAGE(field("pageId")).then((res) => {
      if (res.status == "1") {
        setDataList(res.data);
      }
      setLoader(false);
    });
  };

  const pageField = (fieldName) => dataList[fieldName] || "";

  return (
    <section
      className="py-2"
      style={{ backgroundColor: field("bgColor") || "#fff" }}
    >
      {loader && (
        <center>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </center>
      )}

      {dataList && dataList.id && (
        <>
          {field("pageTitle") && (
            <>
              <h4 className="py-3 text-center">{field("pageTitle")}</h4>
            </>
          )}

          <div
            dangerouslySetInnerHTML={{
              __html: context.isRegionalLanguage()
                ? pageField("content_html_unicode") || pageField("content_html")
                : pageField("content_html"),
            }}
          />
        </>
      )}
    </section>
  );
};

export default HomeAboutUsPage;
